import Vue from 'vue'
export var bus = new Vue()

// common VAR
export var api_dir = "https://pmglab.top/common/api/gec"
export var common_api_dir="https://pmglab.top/common/api/gec"

// common Function
export function setCookie (name,value) {
    var Days = 30
    var exp = new Date()
    exp.setTime(exp.getTime() + Days*24*60*60*1000)
    document.cookie = name + "="+ escape (value) + ";expires=" + exp.toGMTString()
} 
  
export function getCookie (name) {
    var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
    if(arr=document.cookie.match(reg)) {
        return unescape(arr[2])
    } else {
        return null
    }
}

export function delCookie (name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1)
    var cval=getCookie(name);
    if(cval!=null)
    document.cookie= name + "="+cval+";expires="+exp.toGMTString()
}
export function getTime(time_s) {
    if (time_s == -1) {
        return '';
    }
    var date = new Date(time_s * 1000);
    var y = date.getFullYear(),
        m = date.getMonth() + 1,
        d = date.getDate(),
        h = date.getHours(),
        i = date.getMinutes(),
        s = date.getSeconds();
    if (m < 10) { m = '0' + m; }
    if (d < 10) { d = '0' + d; }
    if (h < 10) { h = '0' + h; }
    if (i < 10) { i = '0' + i; }
    if (s < 10) { s = '0' + s; }
    var t = y + '-' + m + '-' + d + ' ' + h + ':' + i + ':' + s;
    return t;
}


// WEBPACK FOOTER //
// ./src/bus.js